import React, { memo } from 'react';

import Popup from '../helpers/Popup';
import BaseButton from '../helpers/Button';
import LoadAnimation from '../decorators/LoadAnimation';
import Select from '../helpers/Select';
import Checkbox from '../helpers/Checkbox';
import { WarningMessage } from '../helpers/WarningMessage';

const Button = LoadAnimation(BaseButton, undefined, undefined, true);

const UpdateHighStatusPopup = props => {
  const { statuses, highStatus, onChange, onSave, onClose, correcting, loading, shouldSendEmail } = props;
  const footer = (
    <>
      <Button
        key="save"
        className="btn-primary"
        data-dismiss="modal"
        disabled={!correcting}
        loading={loading}
        onClick={onSave}
        autoFocus
      >
        {shouldSendEmail ? 'Email Director' : 'Save'}
      </Button>
      <Button key="close" data-dismiss="modal" onClick={onClose}>
        Close
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header="Update High Status" id="updateHighStatusPopup">
      <div className="row">
        <div className="col-md-12 form-group">
          <Checkbox
            checked={correcting}
            label="The High Status was changed in error, and I am correcting the mistake."
            name="correcting"
            onChange={onChange}
          />
          <WarningMessage
            messageText="(High Status was changed more than 24 hours ago and needs Director approval to change.)"
            show={shouldSendEmail}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
          <Select
            disabled={!correcting}
            emptyValue=""
            label="High Status"
            name="highStatus"
            onChange={onChange}
            options={statuses}
            value={highStatus}
            showLabel
            showValue
          />
        </div>
      </div>
    </Popup>
  );
};

export default memo(UpdateHighStatusPopup);
